/**
 * NMS Flash Coupon - tap-to-copy coupon pill.
 * Delegated click handler, bound once per page (safe with multiple
 * sections and with theme-editor re-renders).
 */
(() => {
  if (window.__nmsFlashCouponBound) return;
  window.__nmsFlashCouponBound = true;

  const RESET_MS = 2000;

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    // Fallback for older in-app browsers (no async clipboard API)
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(field);
    if (!ok) throw new Error('copy failed');
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-flash-coupon-copy]');
    if (!button) return;

    const code = button.dataset.flashCouponCopy;
    const status = button.closest('[data-flash-coupon]')?.querySelector('[data-flash-coupon-status]');

    try {
      await copyText(code);
    } catch (error) {
      if (status) status.textContent = `Could not copy. Use code ${code}`;
      return;
    }

    button.classList.add('is-copied');
    if (status) status.textContent = `Code ${code} copied`;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'flash_coupon_copy', coupon_code: code });

    window.clearTimeout(button._nmsCouponTimer);
    button._nmsCouponTimer = window.setTimeout(() => {
      button.classList.remove('is-copied');
      if (status) status.textContent = '';
    }, RESET_MS);
  });
})();